var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.linkTo('editInfo')}}},[_c('span',[_vm._v("个人信息")]),_vm._v(" "),_c('img',{staticClass:"back",attrs:{"src":require("./../../assets/images/index/img_back.png"),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-107e7737","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/setting.vue
// module id = Qp5N
// module chunks = 0